import React from 'react';
// @TECHDEBT: this component should be imported using lazy loading, but API is initialized before setting the env
export { ImmersiveExperience } from './ImmersiveExperience';
export const BookNowButton = React.lazy(() => import(
/* webpackChunkName: "be-book-now-button-wc" */ './BookNowButton').then((module) => ({
    default: module.BookNowButton,
})));
export const GlobalConfig = React.lazy(() => import(/* webpackChunkName: "be-config-wc" */ './GlobalConfig').then((module) => ({
    default: module.GlobalConfig,
})));
export const ImmersiveExperiencePopup = React.lazy(() => import(
/* webpackChunkName: "be-immersive-experience-wc" */ './ImmersiveExperiencePopup').then((module) => ({ default: module.ImmersiveExperiencePopup })));
export const AccommodationDatePicker = React.lazy(() => import(
/* webpackChunkName: "be-accommodation-date-picker-wc" */ './AccommodationDatePicker').then((module) => ({
    default: module.AccommodationDatePickerWebComponent,
})));
export const PropertyDatePicker = React.lazy(() => import(
/* webpackChunkName: "be-property-date-picker-wc" */ './PropertyDatePicker').then((module) => ({
    default: module.PropertyDatePickerWebComponent,
})));
export const MultiPropertyDatePicker = React.lazy(() => import(
/* webpackChunkName: "be-multi-property-date-picker-wc" */ './MultiPropertyDatePicker').then((module) => ({
    default: module.MultiPropertyDatePickerWebComponent,
})));
